const markerInfo = {
  manufacturerLocation: {
    label: 'Manufacturer',
    color: '#788C94',
  },
  materialMillLocation: {
    label: 'Material Mill 1',
    color: '#B9E6B7',
  },
  material1MillLocation: {
    label: 'Material Mill 1',
    color: '#B9E6B7',
  },
  materialSpinnerLocation: {
    label: 'Material Spinner 1',
    color: '#C9BB88',
  },
  materialMfgLocation: {
    label: 'Material Manufacturer',
    color: '#B9E6B7',
  },
  material1SpinnerLocation: {
    label: 'Material Spinner 1',
    color: '#C9BB88',
  },
  material2MillLocation: {
    label: 'Material Mill 2',
    color: '#B9E6B7',
  },
  material2SpinnerLocation: {
    label: 'Material Spinner 2',
    color: '#C9BB88',
  },
  componentASourceLocation: {
    label: 'Component Source 1',
    color: '#27A58E',
  },
  componentBSourceLocation: {
    label: 'Component Source 2',
    color: '#27A58E',
  },
  componentCSourceLocation: {
    label: 'Component Source 3',
    color: '#27A58E',
  },
  btn1ManufacturerLocation: {
    label: 'Button Manufacturer 1',
    color: '#A16D5F',
  },
  button1ManufacturerLocation: {
    label: 'Button Manufacturer 1',
    color: '#A16D5F',
  },
  btn2ManufacturerLocation: {
    label: 'Button Manufacturer 2',
    color: '#A16D5F',
  },
  button2ManufacturerLocation: {
    label: 'Button Manufacturer 2',
    color: '#A16D5F',
  },
  btn3ManufacturerLocation: {
    label: 'Button Manufacturer 3',
    color: '#A16D5F',
  },
  button3ManufacturerLocation: {
    label: 'Button Manufacturer 3',
    color: '#A16D5F',
  },
  button1ComponentASourceLocation: {
    label: 'Button Component Source 1',
    color: '#27A58E',
  },
  button2ComponentASourceLocation: {
    label: 'Button Component Source 2',
    color: '#27A58E',
  },
  button3ComponentASourceLocation: {
    label: 'Button Component Source 3',
    color: '#27A58E',
  },
  subContractorLocation: {
    label: 'Sub Contractor Location',
    color: '#788C94',
  },
  material1ComponentASourceLocation: {
    label: 'Material Component Source 1',
    color: '#27A58E',
  },
  material1ComponentAPulpProcessorLocation: {
    label: 'Pulp Processor 1',
    color: '#788C94',
  },
  material1ComponentASpoolerLocation: {
    label: 'Material Component Spooler 1',
    color: '#27A58E',
  },
  material1ComponentBSourceLocation: {
    label: 'Material Component Source 1',
    color: '#27A58E',
  },
  material1ComponentCSourceLocation: {
    label: 'Material Component Source 2',
    color: '#27A58E',
  },
  componentAProcessorLocation: {
    label: 'Component Processor 1',
    color: '#788C94',
  },
  mfgLocation: {
    label: 'MFG Location',
    color: '#788C94',
  },
  factoryLocation: {
    label: 'Factory Location',
    color: '#788C94',
  },
  dcLocation: {
    label: 'Distribution Center',
    color: '#FF6B6B',
  },
}
